import React from "react";
import AIAppPage from "src/Ateam-BI/Templates/TemplateAI";

function AutomatedAppEditForm({ item, userId, onSave, onCancel }) {
  return (
    <AIAppPage
      id={item.app_id}
      renderJson={item}
      onSave={onSave}
      onCancel={onCancel}
      isEditOverride={true}
    />
  );
}

export default AutomatedAppEditForm;
